import { render } from "./PropertyDetails.vue?vue&type=template&id=85efe8a2"
import script from "./PropertyDetails.vue?vue&type=script&lang=js"
export * from "./PropertyDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__